export const ADD_WELCOME_SUCCESS = 'ADD_WELCOME_SUCCESS';
export const LOAD_WELCOME_SUCCESS = 'LOAD_WELCOME_SUCCESS';